<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-6 col-md-4">
                      <h1 class="primary-color">Positions</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-6 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreatePosition">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create position
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreatePosition"
                  outlined
                  :color="successfullCreatePosition ? 'success' : 'error'"
                  :icon="successfullCreatePosition ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreatePosition }}
                </v-alert>
                <v-alert
                  v-if="messageDeletePosition"
                  outlined
                  :color="successfullDeletePosition ? 'success' : 'error'"
                  :icon="successfullDeletePosition ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeletePosition }}
                </v-alert>
                <v-alert
                  v-if="messageEditPosition"
                  outlined
                  :color="successfullEditPosition ? 'success' : 'error'"
                  :icon="successfullEditPosition ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditPosition }}
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="positions"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait..."
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.introVideo`]="{ item }">
                    <v-icon v-if="item.introVideo" color="success" size="20">
                      mdi-check-circle
                    </v-icon>
                    <v-icon v-else color="grey" size="20"> mdi-minus-circle </v-icon>
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditPosition(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit position</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeletePosition(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete position</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messagePositions"
              class="mt-4"
              outlined
              :color="successfullPositions ? 'success' : 'error'"
              :icon="successfullPositions ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messagePositions }}
            </v-alert>

            <v-alert
              v-if="messageJobs"
              class="mt-4"
              outlined
              :color="successfullJobs ? 'success' : 'error'"
              :icon="successfullJobs ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageJobs }}
            </v-alert>

            <v-alert
              v-if="messageInterviewTypes"
              class="mt-4"
              outlined
              :color="successfullInterviewTypes ? 'success' : 'error'"
              :icon="successfullInterviewTypes ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageInterviewTypes }}
            </v-alert>

            <v-alert
              v-if="messageVisibleBehaviours"
              class="mt-4"
              outlined
              :color="successfullVisibleBehaviours ? 'success' : 'error'"
              :icon="successfullVisibleBehaviours ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageVisibleBehaviours }}
            </v-alert>

            <v-alert
              v-if="messageContexts"
              class="mt-4"
              outlined
              :color="successfullContexts ? 'success' : 'error'"
              :icon="successfullContexts ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageContexts }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createPositionDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createPositionForm" @submit.prevent="createPosition">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Position</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container class="px-0">
              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Information</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        v-model="position.name"
                        class="py-0 mb-6 no-border-radius"
                        label="Name *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-textarea
                        v-model="position.description"
                        class="py-0 mb-6 no-border-radius"
                        label="Description *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        v-model="position.publicName"
                        class="py-0 mb-6 no-border-radius"
                        label="Public name *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-textarea
                        v-model="position.publicDescription"
                        class="py-0 mb-6 no-border-radius"
                        label="Public description *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-file-input
                        v-model="position.introVideo"
                        class="py-0 mb-0 no-border-radius"
                        label="Introduction Video (Optional)"
                        accept="video/*"
                        prepend-icon="mdi-video"
                        show-size
                        dense
                        clearable
                        hint="Optional intro video for candidates"
                        persistent-hint
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Classification</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-select
                        ref="menuJobsCreate"
                        v-model="position.jobId"
                        class="py-0 mb-6 no-border-radius"
                        label="Job *"
                        :items="jobsCreate"
                        item-text="name"
                        item-value="id"
                        :loading="loadingJobsCreate"
                        attach
                        :menu-props="{
                          maxHeight: '180px !important',
                        }"
                      />
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-select
                        ref="menuInterviewTypesCreate"
                        v-model="position.interviewTypeId"
                        class="py-0 mb-6 no-border-radius"
                        label="Interview type *"
                        :items="interviewTypesCreate"
                        item-text="name"
                        item-value="id"
                        :loading="loadingInterviewTypesCreate"
                        attach
                        :menu-props="{
                          maxHeight: '180px !important',
                        }"
                        @change="onInterviewTypeChangeCreate"
                      />
                    </v-col>
                    <v-col
                      v-if="hasListComponentCreate"
                      cols="12"
                      class="pb-0"
                    >
                      <h6 class="text-body-2 mb-2 primary--text">List options (beliefs order) *</h6>
                      <p class="text-caption mb-2 grey--text">
                        This interview type has a LIST component. Set options in the client&apos;s ideal order; all candidates see the same fixed sequence (order is not randomized).
                      </p>
                      <v-list
                        dense
                        class="mt-2"
                        :key="'list-options-create-' + listOptionsCreateKey"
                      >
                        <v-list-item
                          v-for="(opt, idx) in position.listOptions"
                          :key="'create-' + idx"
                          class="px-0"
                        >
                          <v-list-item-content class="py-0">
                            <v-row align="center" no-gutters>
                              <v-col cols="1" class="pr-2">
                                <span class="text-body-2">{{ idx + 1 }}.</span>
                              </v-col>
                              <v-col cols="10">
                                <v-text-field
                                  v-model="opt.content"
                                  dense
                                  hide-details
                                  label="Option content"
                                  class="py-0"
                                />
                              </v-col>
                              <v-col cols="1">
                                <v-btn type="button" icon x-small @click.prevent="removeListOptionCreate(idx)">
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-btn
                        type="button"
                        small
                        text
                        class="mt-2"
                        @click.native.prevent="addListOptionCreate"
                      >
                        Add option
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Analysis</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-autocomplete
                        ref="menuVisibleBehavioursCreate"
                        v-model="position.selectedVisibleBehaviourIds"
                        class="py-0 mb-6 no-border-radius"
                        label="Visible Behaviours *"
                        :items="visibleBehavioursCreate"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        :loading="loadingVisibleBehavioursCreate"
                        attach
                        :menu-props="{
                          maxHeight: '180px !important',
                        }"
                        @change="syncVisibleBehavioursWithWeightsCreate"
                      />
                      <v-simple-table v-if="position.visibleBehavioursWithWeights.length > 0" dense class="mt-2">
                        <thead>
                          <tr>
                            <th class="text-left text-body-2 primary--text">Visible Behaviour</th>
                            <th class="text-left text-body-2 primary--text" style="width: 120px">Weights</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="vb in position.visibleBehavioursWithWeights" :key="vb.id">
                            <td class="visible-behaviour-name-col">
                              <span class="text-body-2 visible-behaviour-name">{{
                                visibleBehavioursCreate.find((v) => v.id === vb.id)?.name || ''
                              }}</span>
                            </td>
                            <td>
                              <v-text-field
                                v-model.number="vb.weight"
                                type="number"
                                min="0"
                                step="0.5"
                                dense
                                hide-details
                                class="py-0"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Interview context</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-autocomplete
                        ref="menuContextsCreate"
                        v-model="position.contexts"
                        class="py-0 mb-0 no-border-radius"
                        label="Contexts *"
                        :items="contextsCreate"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        :loading="loadingContextsCreate"
                        attach
                        :menu-props="{
                          maxHeight: '180px !important',
                        }"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-alert
                v-if="messageCreatePositionInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreatePositionInside ? 'success' : 'error'"
                :icon="successfullCreatePositionInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreatePositionInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreatePosition"> Cancel </v-btn>
            <v-btn v-if="!creatingPosition" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editPositionDialog" max-width="600" persistent>
      <v-card>
        <v-overlay v-if="loadingEditPosition" absolute opacity="0.7">
          <v-progress-circular indeterminate color="primary" size="48" />
        </v-overlay>
        <v-form ref="editPositionForm" @submit.prevent="editPosition">
          <v-card-title class="px-6">
            <h5 class="primary-color">Edit Position</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container class="px-0">
              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Information</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        v-model="itemToEdit.name"
                        class="py-0 mb-6 no-border-radius"
                        label="Name *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-textarea
                        v-model="itemToEdit.description"
                        class="py-0 mb-6 no-border-radius"
                        label="Description *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        v-model="itemToEdit.publicName"
                        class="py-0 mb-6 no-border-radius"
                        label="Public name *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-textarea
                        v-model="itemToEdit.publicDescription"
                        class="py-0 mb-6 no-border-radius"
                        label="Public description *"
                        :rules="rules"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-chip
                        v-if="itemToEdit.hasIntroVideo"
                        class="mb-2"
                        small
                        color="success"
                        text-color="white"
                      >
                        <v-icon left small>mdi-check-circle</v-icon>
                        Video loaded
                      </v-chip>
                      <v-file-input
                        v-model="itemToEdit.introVideo"
                        class="py-0 mb-0 no-border-radius"
                        label="Introduction Video (Optional)"
                        accept="video/*"
                        prepend-icon="mdi-video"
                        show-size
                        dense
                        clearable
                        hint="Optional intro video for candidates. Leave empty to keep current video."
                        persistent-hint
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Classification</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-select
                        v-model="itemToEdit.jobId"
                        class="py-0 mb-6 no-border-radius"
                        label="Job *"
                        :items="jobsEdit"
                        item-text="name"
                        item-value="id"
                      />
                    </v-col>
                    <v-col cols="12" class="pb-0">
                      <v-select
                        v-model="itemToEdit.interviewTypeId"
                        class="py-0 mb-6 no-border-radius"
                        label="Interview type *"
                        :items="interviewTypesEdit"
                        item-text="name"
                        item-value="id"
                        @change="onInterviewTypeChangeEdit"
                      />
                    </v-col>
                    <v-col
                      v-if="hasListComponentEdit"
                      cols="12"
                      class="pb-0"
                    >
                      <h6 class="text-body-2 mb-2 primary--text">List options (beliefs order) *</h6>
                      <p class="text-caption mb-2 grey--text">
                        This interview type has a LIST component. Set options in the client&apos;s ideal order; all candidates see the same fixed sequence (order is not randomized).
                      </p>
                      <v-list
                        dense
                        class="mt-2"
                        :key="'list-options-edit-' + listOptionsEditKey"
                      >
                        <v-list-item
                          v-for="(opt, idx) in itemToEdit.listOptions"
                          :key="'edit-' + idx"
                          class="px-0"
                        >
                          <v-list-item-content class="py-0">
                            <v-row align="center" no-gutters>
                              <v-col cols="1" class="pr-2">
                                <span class="text-body-2">{{ idx + 1 }}.</span>
                              </v-col>
                              <v-col cols="10">
                                <v-text-field
                                  v-model="opt.content"
                                  dense
                                  hide-details
                                  label="Option content"
                                  class="py-0"
                                />
                              </v-col>
                              <v-col cols="1">
                                <v-btn type="button" icon x-small @click.prevent="removeListOptionEdit(idx)">
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-btn
                        type="button"
                        small
                        text
                        class="mt-2"
                        @click.native.prevent="addListOptionEdit"
                      >
                        Add option
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Analysis</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-autocomplete
                        v-model="itemToEdit.selectedVisibleBehaviourIds"
                        class="py-0 mb-6 no-border-radius"
                        label="Visible Behaviours *"
                        :items="visibleBehavioursEdit"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        menu-props="{ top: true }"
                        @change="syncVisibleBehavioursWithWeightsEdit"
                      />
                      <v-simple-table v-if="itemToEdit.visibleBehavioursWithWeights?.length > 0" dense class="mt-2">
                        <thead>
                          <tr>
                            <th class="text-left text-body-2 primary--text">Visible Behaviour</th>
                            <th class="text-left text-body-2 primary--text" style="width: 120px">Weights</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="vb in itemToEdit.visibleBehavioursWithWeights" :key="vb.id">
                            <td class="visible-behaviour-name-col">
                              <span class="text-body-2 visible-behaviour-name">{{
                                visibleBehavioursEdit.find((v) => v.id === vb.id)?.name || ''
                              }}</span>
                            </td>
                            <td>
                              <v-text-field
                                v-model.number="vb.weight"
                                type="number"
                                min="0"
                                step="0.5"
                                dense
                                hide-details
                                class="py-0"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card outlined elevation="0" class="mb-4">
                <v-card-title class="text-subtitle-1 primary--text py-3">Interview context</v-card-title>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-autocomplete
                        v-model="itemToEdit.contexts"
                        class="py-0 mb-0 no-border-radius"
                        label="Contexts *"
                        :items="contextsEdit"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        menu-props="{ top: true }"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-alert
                v-if="messageEditPositionInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditPositionInside ? 'success' : 'error'"
                :icon="successfullEditPositionInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditPositionInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editPositionDialog = false"> Cancel </v-btn>
            <v-btn v-if="!editingPosition && !loadingEditPosition" type="submit" class="ok-modal">
              Edit
            </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deletePositionDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Position</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <p class="mb-0">
            Do you really want to delete the selected position? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deletePositionDialog = false"> Cancel </v-btn>

          <template v-if="!deletingPosition">
            <v-btn class="ok-modal" @click="deletePosition"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deletePosition">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsPositionDialog" max-width="800">
      <v-card>
        <v-form ref="detailsPositionForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Description:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.description }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Public name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.publicName }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Public description:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.publicDescription }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Job:</h6>
                </v-col>
                <v-col cols="9">
                  <p v-if="itemToShow.job !== undefined" class="mb-0">
                    {{ itemToShow.job.name }}
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Interview type:</h6>
                </v-col>
                <v-col cols="9">
                  <p v-if="itemToShow.interviewType !== undefined" class="mb-0">
                    {{ itemToShow.interviewType.name }}
                  </p>
                </v-col>
              </v-row>

              <v-row v-if="itemToShow.introVideo">
                <v-col cols="12" class="pb-0">
                  <h6 class="details-subtitles primary-color">Introduction Video:</h6>
                </v-col>
                <v-col cols="12" class="py-0">
                  <video
                    controls
                    :src="getIntroVideoUrl(itemToShow.introVideo)"
                    width="100%"
                    height="auto"
                    class="intro-video-player"
                    style="max-height: 400px; border-radius: 8px"
                  ></video>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Introduction Video:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0 grey--text">No intro video uploaded</p>
                </v-col>
              </v-row>

              <v-row v-if="itemToShow.contexts !== undefined && itemToShow.contexts.length == 0">
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Contexts:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">Position with no associated contexts</p>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" class="pb-0">
                  <h6 class="details-subtitles primary-color">Contexts:</h6>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-data-table
                    :headers="headersDetails"
                    :items="itemToShow.contexts"
                    item-key="itemToShow.id"
                    item-class="text-wrap"
                  >
                    <template #[`item.content`]="{ item }">
                      {{ item.content | slice100Characters }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>

              <v-row
                v-if="
                  itemToShow.visibleBehaviours !== undefined &&
                  itemToShow.visibleBehaviours.length == 0
                "
              >
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Visible Behaviours:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">Position with no associated visible behaviours</p>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" class="pb-0">
                  <h6 class="details-subtitles primary-color">Visible Behaviours:</h6>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-data-table
                    :headers="headersDetailsVisibleBehaviours"
                    :items="itemToShow.visibleBehaviours || []"
                    item-key="id"
                    item-class="text-wrap"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsPositionDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VisibleBehavioursDataService from '@/services/VisibleBehavioursDataService';
import ContextsDataService from '@/services/ContextsDataService';
import InterviewsDataService from '@/services/InterviewsDataService';
import JobsDataService from '@/services/JobsDataService';
import PositionsDataService from '@/services/PositionsDataService';
import utils from '@/utils/utils.js';

const LIST_COMPONENT_TYPE = 'list';

export default {
  name: 'PositionsList',
  data() {
    return {
      positions: [],
      successfullPositions: false,
      messagePositions: '',
      jobsCreate: [],
      jobsEdit: [],
      successfullJobs: false,
      messageJobs: '',
      interviewTypesCreate: [],
      interviewTypesEdit: [],
      successfullInterviewTypes: false,
      messageInterviewTypes: '',
      visibleBehavioursCreate: [],
      visibleBehavioursEdit: [],
      successfullVisibleBehaviours: false,
      messageVisibleBehaviours: '',
      contextsCreate: [],
      contextsEdit: [],
      successfullContexts: false,
      messageContexts: '',
      users: [],
      successfullUsers: false,
      messageUsers: '',
      loading: false,
      successfullCreatePosition: false,
      messageCreatePosition: '',
      successfullCreatePositionInside: false,
      messageCreatePositionInside: '',
      successfullEditPosition: false,
      messageEditPosition: '',
      successfullEditPositionInside: false,
      messageEditPositionInside: '',
      successfullDeletePosition: false,
      messageDeletePosition: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Job', value: 'job.name', sortable: false },
        {
          text: 'Interview type',
          value: 'interviewType.name',
          sortable: false,
        },
        {
          text: 'Visible Behaviours',
          value: 'visibleBehaviours.length',
          sortable: false,
          width: '150px',
        },
        {
          text: 'Contexts',
          value: 'contexts.length',
          sortable: false,
          width: '150px',
        },
        {
          text: 'Created at',
          value: 'createdAt',
          sortable: false,
          width: '200px',
        },
        {
          text: 'Intro Video',
          value: 'introVideo',
          sortable: false,
          width: '120px',
        },
        { text: 'Actions', value: 'actions', sortable: false, width: '200px' },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      position: {
        name: '',
        description: '',
        publicName: '',
        publicDescription: '',
        jobId: null,
        interviewTypeId: null,
        selectedVisibleBehaviourIds: [],
        visibleBehavioursWithWeights: [],
        contexts: [],
        listOptions: [],
        status: 1,
        introVideo: null,
      },
      hasListComponentCreate: false,
      hasListComponentEdit: false,
      listOptionsCreateKey: 0,
      listOptionsEditKey: 0,
      rules: [(v) => !!v || 'Required field'],
      createPositionDialog: false,
      creatingPosition: false,
      editPositionDialog: false,
      loadingEditPosition: false,
      editingPosition: false,
      deletePositionDialog: false,
      deletingPosition: false,
      itemToEdit: {},
      itemToDelete: {},
      itemToShow: {},
      headersDetails: [
        { text: 'Name', value: 'name' },
        { text: 'Content', value: 'content' },
      ],
      headersDetailsVisibleBehaviours: [
        { text: 'Name', value: 'name' },
        { text: 'Id Beon', value: 'idBeon' },
        { text: 'Weight', value: 'weight' },
      ],
      showDetailsPositionDialog: false,

      pageJobsCreate: 1,
      totalItemsJobsCreate: 0,
      itemsPerPageJobsCreate: 10,
      loadingJobsCreate: false,
      isMenuOpenJobsCreate: false,

      pageInterviewTypesCreate: 1,
      totalItemsInterviewTypesCreate: 0,
      itemsPerPageInterviewTypesCreate: 10,
      loadingInterviewTypesCreate: false,
      isMenuOpenInterviewTypesCreate: false,

      pageVisibleBehavioursCreate: 1,
      totalItemsVisibleBehavioursCreate: 0,
      itemsPerPageVisibleBehavioursCreate: 10,
      loadingVisibleBehavioursCreate: false,
      isMenuOpenVisibleBehavioursCreate: false,

      pageContextsCreate: 1,
      totalItemsContextsCreate: 0,
      itemsPerPageContextsCreate: 10,
      loadingContextsCreate: false,
      isMenuOpenContextsCreate: false,
    };
  },
  async mounted() {
    await this.getAllJobsEdit();
    await this.getAllInterviewTypesEdit();
    await this.getAllVisibleBehavioursEdit();
    await this.getAllContextsEdit();
    await this.getAllPositions(1);
  },
  methods: {
    getIntroVideoUrl(introVideo) {
      if (!introVideo) return '';
      return `${utils.config.publicBucketURL}/${introVideo}`;
    },
    getAllPositions(page) {
      this.loading = true;

      PositionsDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.positions = response.data.data;

            if (this.positions.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullPositions = false;
            this.messagePositions =
              'An error has occurred retrieving the list of positions. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullPositions = false;
          this.messagePositions =
            'An error has occurred retrieving the list of positions. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllPositions(newPage);
    },
    observeMenuJobsCreate() {
      const menu = this.$refs.menuJobsCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenJobsCreate) {
            this.onOpenJobsCreate(true);
            this.isMenuOpenJobsCreate = true;
            dropdown.addEventListener('scroll', this.onScrollJobsCreate);
          } else if (!dropdown && this.isMenuOpenJobsCreate) {
            this.onOpenJobsCreate(false);
            this.isMenuOpenJobsCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllJobsCreate() {
      this.loadingJobsCreate = true;

      JobsDataService.findAll(this.pageJobsCreate, this.itemsPerPageJobsCreate).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingJobsCreate = false;
              return;
            }

            this.jobsCreate = [...this.jobsCreate, ...response.data.data];
            this.totalItemsJobsCreate = response.data.links.totalItems;
            this.pageJobsCreate++;
          } else {
            this.successfullJobs = false;
            this.messageJobs =
              'An error has occurred retrieving the list of jobs. Please, try again later.';
          }

          this.loadingJobsCreate = false;
        },
        (error) => {
          this.successfullJobs = false;
          this.messageJobs =
            'An error has occurred retrieving the list of jobs. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingJobsCreate = false;
        }
      );
    },
    onOpenJobsCreate(isOpen) {
      if (isOpen && this.jobsCreate.length === 0) {
        this.getAllJobsCreate();
      }
    },
    onScrollJobsCreate(event) {
      const dropdown = event.target;

      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingJobsCreate
      ) {
        this.getAllJobsCreate();
      }
    },
    getAllJobsEdit() {
      this.loading = true;

      JobsDataService.findAll(-1, 0).then(
        (response) => {
          if (response.status == 200) this.jobsEdit = response.data.data;
          else {
            this.successfullJobs = false;
            this.messageJobs =
              'An error has occurred retrieving the list of jobs. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullJobs = false;
          this.messageJobs =
            'An error has occurred retrieving the list of jobs. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    observeMenuInterviewTypesCreate() {
      const menu = this.$refs.menuInterviewTypesCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenInterviewTypesCreate) {
            this.onOpenInterviewTypesCreate(true);
            this.isMenuOpenInterviewTypesCreate = true;
            dropdown.addEventListener('scroll', this.onScrollInterviewTypesCreate);
          } else if (!dropdown && this.isMenuOpenInterviewTypesCreate) {
            this.onOpenInterviewTypesCreate(false);
            this.isMenuOpenInterviewTypesCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllInterviewTypesCreate() {
      this.loadingInterviewTypesCreate = true;

      InterviewsDataService.findAllInterviewTypes(
        this.pageInterviewTypesCreate,
        this.itemsPerPageInterviewTypesCreate
      ).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingInterviewTypesCreate = false;
              return;
            }

            this.interviewTypesCreate = [...this.interviewTypesCreate, ...response.data.data];
            this.totalItemsInterviewTypesCreate = response.data.links.totalItems;
            this.pageInterviewTypesCreate++;
          } else {
            this.successfullInterviewTypes = false;
            this.messageInterviewTypes =
              'An error has occurred retrieving the list of interview types. Please, try again later.';
          }

          this.loadingInterviewTypesCreate = false;
        },
        (error) => {
          this.successfullInterviewTypes = false;
          this.messageInterviewTypes =
            'An error has occurred retrieving the list of interview types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingInterviewTypesCreate = false;
        }
      );
    },
    onOpenInterviewTypesCreate(isOpen) {
      if (isOpen && this.interviewTypesCreate.length === 0) {
        this.getAllInterviewTypesCreate();
      }
    },
    onScrollInterviewTypesCreate(event) {
      const dropdown = event.target;

      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingInterviewTypesCreate
      ) {
        this.getAllInterviewTypesCreate();
      }
    },
    getAllInterviewTypesEdit() {
      this.loading = true;

      InterviewsDataService.findAllInterviewTypes(-1, 0).then(
        (response) => {
          if (response.status == 200) this.interviewTypesEdit = response.data.data;
          else {
            this.successfullInterviewTypes = false;
            this.messageInterviewTypes =
              'An error has occurred retrieving the list of interview types. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullInterviewTypes = false;
          this.messageInterviewTypes =
            'An error has occurred retrieving the list of interview types. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    syncVisibleBehavioursWithWeightsCreate() {
      const ids = this.position.selectedVisibleBehaviourIds || [];
      const current = this.position.visibleBehavioursWithWeights || [];
      const updated = ids.map((id) => {
        const existing = current.find((vb) => vb.id === id);
        return existing ? { id, weight: existing.weight } : { id, weight: 5.0 };
      });
      this.position.visibleBehavioursWithWeights = updated;
    },
    syncVisibleBehavioursWithWeightsEdit() {
      const ids = this.itemToEdit.selectedVisibleBehaviourIds || [];
      const current = this.itemToEdit.visibleBehavioursWithWeights || [];
      const updated = ids.map((id) => {
        const existing = current.find((vb) => vb.id === id);
        return existing ? { id, weight: existing.weight } : { id, weight: 5.0 };
      });
      this.itemToEdit.visibleBehavioursWithWeights = updated;
    },
    observeMenuVisibleBehavioursCreate() {
      const menu = this.$refs.menuVisibleBehavioursCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenVisibleBehavioursCreate) {
            this.onOpenVisibleBehavioursCreate(true);
            this.isMenuOpenVisibleBehavioursCreate = true;
            dropdown.addEventListener('scroll', this.onScrollVisibleBehavioursCreate);
          } else if (!dropdown && this.isMenuOpenVisibleBehavioursCreate) {
            this.onOpenVisibleBehavioursCreate(false);
            this.isMenuOpenVisibleBehavioursCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllVisibleBehavioursCreate() {
      this.loadingVisibleBehavioursCreate = true;

      VisibleBehavioursDataService.findAll(
        this.pageVisibleBehavioursCreate,
        this.itemsPerPageVisibleBehavioursCreate
      ).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingVisibleBehavioursCreate = false;
              return;
            }

            this.visibleBehavioursCreate = [
              ...this.visibleBehavioursCreate,
              ...response.data.data,
            ];
            this.totalItemsVisibleBehavioursCreate = response.data.links.totalItems;
            this.pageVisibleBehavioursCreate++;
          } else {
            this.successfullVisibleBehaviours = false;
            this.messageVisibleBehaviours =
              'An error has occurred retrieving the list of visible behaviours. Please, try again later.';
          }

          this.loadingVisibleBehavioursCreate = false;
        },
        (error) => {
          this.successfullVisibleBehaviours = false;
          this.messageVisibleBehaviours =
            'An error has occurred retrieving the list of visible behaviours. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingVisibleBehavioursCreate = false;
        }
      );
    },
    onOpenVisibleBehavioursCreate(isOpen) {
      if (isOpen && this.visibleBehavioursCreate.length === 0) {
        this.getAllVisibleBehavioursCreate();
      }
    },
    onScrollVisibleBehavioursCreate(event) {
      const dropdown = event.target;

      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingVisibleBehavioursCreate
      ) {
        this.getAllVisibleBehavioursCreate();
      }
    },
    getAllVisibleBehavioursEdit() {
      this.loading = true;

      VisibleBehavioursDataService.findAll(-1, 0).then(
        (response) => {
          if (response.status == 200) this.visibleBehavioursEdit = response.data.data;
          else {
            this.successfullVisibleBehaviours = false;
            this.messageVisibleBehaviours =
              'An error has occurred retrieving the list of visible behaviours. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullVisibleBehaviours = false;
          this.messageVisibleBehaviours =
            'An error has occurred retrieving the list of visible behaviours. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    observeMenuContextsCreate() {
      const menu = this.$refs.menuContextsCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenContextsCreate) {
            this.onOpenContextsCreate(true);
            this.isMenuOpenContextsCreate = true;
            dropdown.addEventListener('scroll', this.onScrollContextsCreate);
          } else if (!dropdown && this.isMenuOpenContextsCreate) {
            this.onOpenContextsCreate(false);
            this.isMenuOpenContextsCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllContextsCreate() {
      this.loadingContextsCreate = true;

      ContextsDataService.findAll(this.pageContextsCreate, this.itemsPerPageContextsCreate).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingContextsCreate = false;
              return;
            }

            this.contextsCreate = [...this.contextsCreate, ...response.data.data];
            this.totalItemsContextsCreate = response.data.links.totalItems;
            this.pageContextsCreate++;
          } else {
            this.successfullContexts = false;
            this.messageContexts =
              'An error has occurred retrieving the list of contexts. Please, try again later.';
          }

          this.loadingContextsCreate = false;
        },
        (error) => {
          this.successfullContexts = false;
          this.messageContexts =
            'An error has occurred retrieving the list of contexts. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingContextsCreate = false;
        }
      );
    },
    onOpenContextsCreate(isOpen) {
      if (isOpen && this.contextsCreate.length === 0) {
        this.getAllContextsCreate();
      }
    },
    onScrollContextsCreate(event) {
      const dropdown = event.target;

      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingContextsCreate
      ) {
        this.getAllContextsCreate();
      }
    },
    getAllContextsEdit() {
      this.loading = true;

      ContextsDataService.findAll(-1, 0).then(
        (response) => {
          if (response.status == 200) this.contextsEdit = response.data.data;
          else {
            this.successfullContexts = false;
            this.messageContexts =
              'An error has occurred retrieving the list of contexts. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullContexts = false;
          this.messageContexts =
            'An error has occurred retrieving the list of contexts. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreatePosition() {
      this.createPositionDialog = true;
      this.$nextTick(() => {
        this.observeMenuJobsCreate();
        this.observeMenuInterviewTypesCreate();
        this.observeMenuVisibleBehavioursCreate();
        this.observeMenuContextsCreate();
      });
    },
    normalizeListOptions(listOptions) {
      const src = Array.isArray(listOptions) ? listOptions : [];
      const dedup = new Set();
      const normalized = [];
      src.forEach((opt) => {
        const content = String(opt?.content || '').trim();
        if (!content) return;
        const dedupKey = content.toLowerCase();
        if (dedup.has(dedupKey)) return;
        dedup.add(dedupKey);
        normalized.push({ content });
      });
      return normalized.map((opt, i) => ({ content: opt.content, order: i }));
    },
    createPosition() {
      this.successfullCreatePosition = true;
      this.messageCreatePosition = '';

      if (this.$refs.createPositionForm.validate()) {
        const normalizedCreateListOptions = this.normalizeListOptions(this.position.listOptions);
        if (this.hasListComponentCreate && normalizedCreateListOptions.length === 0) {
          this.messageCreatePositionInside = '';
          this.successfullCreatePositionInside = false;
          this.messageCreatePositionInside =
            'When the interview type has a LIST component, you must add at least one non-empty option.';
          return;
        }

        if (
          this.position.interviewTypeId !== null &&
          this.position.jobId !== null &&
          this.position.contexts.length > 0 &&
          this.position.visibleBehavioursWithWeights.length > 0
        ) {
          this.creatingPosition = true;

          this.position.contextsList = [...this.position.contexts];
          delete this.position.contexts;
          delete this.position.selectedVisibleBehaviourIds;
          this.position.listOptions = normalizedCreateListOptions;

          PositionsDataService.create(this.position).then(
            (response) => {
              if (response.status == 201) {
                this.getAllPositions(1);

                this.messageCreatePosition = '';
                this.successfullCreatePosition = true;

                setTimeout(() => {
                  this.messageCreatePosition = 'Position successfully created.';
                }, 10);
              } else {
                this.messageCreatePosition = '';
                this.successfullCreatePosition = true;

                setTimeout(() => {
                  this.messageCreatePosition =
                    'An error has occurred creating the position. Please, try again later.';
                }, 10);
              }

              this.createPositionDialog = false;
              this.creatingPosition = false;
              this.position = {
                name: '',
                description: '',
                publicName: '',
                publicDescription: '',
                jobId: null,
                interviewTypeId: null,
                selectedVisibleBehaviourIds: [],
                visibleBehavioursWithWeights: [],
                contexts: [],
                listOptions: [],
                status: 1,
                introVideo: null,
              };
              this.hasListComponentCreate = false;
            },
            (error) => {
              this.messageCreatePositionInside = '';
              this.messageCreatePosition = '';

              if (error.response.status === 409) {
                this.successfullCreatePositionInside = false;

                setTimeout(() => {
                  this.messageCreatePositionInside =
                    'Position already in use. Please, change its name.';
                }, 10);
              } else if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('user');
                this.$router.push('/');
              } else {
                this.successfullCreatePosition = false;

                setTimeout(() => {
                  this.messageCreatePosition =
                    'An error has occurred creating the position. Please, try again later.';
                }, 10);

                this.createPositionDialog = false;
                this.position = {
                  name: '',
                  description: '',
                  publicName: '',
                  publicDescription: '',
                  jobId: null,
                  interviewTypeId: null,
                  selectedVisibleBehaviourIds: [],
                  visibleBehavioursWithWeights: [],
                  contexts: [],
                  listOptions: [],
                  status: 1,
                  introVideo: null,
                };
                this.hasListComponentCreate = false;
              }

              console.error(
                (error.response && error.response.data) || error.message || error.toString()
              );

              this.creatingPosition = false;
            }
          );
        } else {
          this.messageCreatePositionInside = '';
          this.successfullCreatePositionInside = false;

          setTimeout(() => {
            this.messageCreatePositionInside = 'Please, fill all fields.';
          }, 10);
        }
      }
    },
    cancelCreatePosition() {
      this.createPositionDialog = false;
      this.position = {
        name: '',
        description: '',
        publicName: '',
        publicDescription: '',
        jobId: null,
        interviewTypeId: null,
        selectedVisibleBehaviourIds: [],
        visibleBehavioursWithWeights: [],
        contexts: [],
        listOptions: [],
        status: 1,
        introVideo: null,
      };
      this.hasListComponentCreate = false;
    },
    async onInterviewTypeChangeCreate(interviewTypeId) {
      if (!interviewTypeId) {
        this.hasListComponentCreate = false;
        this.position.listOptions = [];
        return;
      }
      try {
        const res = await InterviewsDataService.findOneInterviewType(interviewTypeId);
        const data = res.data?.data || res.data;
        const steps = data?.steps || [];
        const hasList = steps.some(
          (s) => s.component && String(s.component.type).toLowerCase() === LIST_COMPONENT_TYPE
        );
        this.hasListComponentCreate = !!hasList;
        if (!hasList) this.$set(this.position, 'listOptions', []);
      } catch (e) {
        this.hasListComponentCreate = false;
        this.$set(this.position, 'listOptions', []);
      }
    },
    async onInterviewTypeChangeEdit(interviewTypeId) {
      if (!interviewTypeId) {
        this.hasListComponentEdit = false;
        this.itemToEdit.listOptions = this.itemToEdit.listOptions || [];
        return;
      }
      try {
        const res = await InterviewsDataService.findOneInterviewType(interviewTypeId);
        const data = res.data?.data || res.data;
        const steps = data?.steps || [];
        const hasList = steps.some(
          (s) => s.component && String(s.component.type).toLowerCase() === LIST_COMPONENT_TYPE
        );
        this.hasListComponentEdit = !!hasList;
        if (!hasList) this.$set(this.itemToEdit, 'listOptions', []);
      } catch (e) {
        this.hasListComponentEdit = false;
      }
    },
    addListOptionCreate() {
      const list = Array.isArray(this.position.listOptions) ? this.position.listOptions : [];
      const newOption = { content: '', order: list.length };
      this.$set(this.position, 'listOptions', [...list, newOption]);
      this.listOptionsCreateKey += 1;
    },
    removeListOptionCreate(idx) {
      const list = this.position.listOptions || [];
      const next = [...list];
      next.splice(idx, 1);
      this.$set(this.position, 'listOptions', next);
      this.listOptionsCreateKey += 1;
    },
    addListOptionEdit() {
      const list = Array.isArray(this.itemToEdit.listOptions) ? this.itemToEdit.listOptions : [];
      const newOption = { content: '', order: list.length };
      this.$set(this.itemToEdit, 'listOptions', [...list, newOption]);
      this.listOptionsEditKey += 1;
    },
    removeListOptionEdit(idx) {
      const list = this.itemToEdit.listOptions || [];
      const next = [...list];
      next.splice(idx, 1);
      this.$set(this.itemToEdit, 'listOptions', next);
      this.listOptionsEditKey += 1;
    },
    async openEditPosition(position) {
      this.editPositionDialog = true;
      this.loadingEditPosition = true;
      try {
        const response = await PositionsDataService.findOne(position.id);
        const data = response.data?.data ?? response.data;
        if (!data) {
          this.messageEditPosition = 'Could not load position details.';
          this.successfullEditPosition = false;
          this.editPositionDialog = false;
          return;
        }

        this.itemToEdit = {
          id: data.id,
          name: data.name,
          description: data.description,
          publicName: data.publicName,
          publicDescription: data.publicDescription,
          status: data.status,
          user: data.user,
          jobId: data.job?.id,
          interviewTypeId: data.interviewType?.id,
          contexts: (data.contexts || []).map((c) => c.id),
          selectedVisibleBehaviourIds: (data.visibleBehaviours || []).map((vb) => vb.id),
          visibleBehavioursWithWeights: (data.visibleBehaviours || []).map((vb) => ({
            id: vb.id,
            weight: vb.weight ?? 5.0,
          })),
          listOptions: (data.listOptions || []).map((s) => ({
            content: s.content || '',
            order: s.order != null ? s.order : 0,
          })),
          hasIntroVideo: !!data.introVideo,
          introVideo: null,
        };

        await this.onInterviewTypeChangeEdit(this.itemToEdit.interviewTypeId);
      } catch (error) {
        this.messageEditPosition =
          (error.response && error.response.data && error.response.data.message) ||
          'An error has occurred loading the position. Please, try again later.';
        this.successfullEditPosition = false;
        this.editPositionDialog = false;
        console.error(
          (error.response && error.response.data) || error.message || error.toString()
        );
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          localStorage.removeItem('user');
          this.$router.push('/');
        }
      } finally {
        this.loadingEditPosition = false;
      }
    },
    editPosition() {
      this.successfullEditPosition = true;

      if (this.$refs.editPositionForm.validate()) {
        const normalizedEditListOptions = this.normalizeListOptions(this.itemToEdit.listOptions);
        if (this.hasListComponentEdit && normalizedEditListOptions.length === 0) {
          this.messageEditPositionInside = '';
          this.successfullEditPositionInside = false;
          this.messageEditPositionInside =
            'When the interview type has a LIST component, you must add at least one non-empty option.';
          return;
        }

        if (
          this.itemToEdit.interviewTypeId !== null &&
          this.itemToEdit.jobId !== null &&
          this.itemToEdit.contexts.length > 0 &&
          this.itemToEdit.visibleBehavioursWithWeights.length > 0
        ) {
          this.editingPosition = true;

          this.itemToEdit.contextsList = [...this.itemToEdit.contexts];
          delete this.itemToEdit.contexts;
          delete this.itemToEdit.selectedVisibleBehaviourIds;
          this.itemToEdit.listOptions = normalizedEditListOptions;

          this.itemToEdit.userId = this.itemToEdit.user.id;

          PositionsDataService.update(this.itemToEdit).then(
            (response) => {
              if (response.status == 204) {
                this.getAllPositions(1);
                this.messageEditPosition = '';
                this.successfullEditPosition = true;

                setTimeout(() => {
                  this.messageEditPosition = 'Position successfully updated.';
                }, 10);
              } else {
                this.messageEditPosition = '';
                this.successfullEditPosition = true;

                setTimeout(() => {
                  this.messageEditPosition =
                    'An error has occurred updating the position. Please, try again later.';
                }, 10);
              }

              this.editPositionDialog = false;
              this.editingPosition = false;
              this.itemToEdit = {};
            },
            (error) => {
              this.messageEditPositionInside = '';
              this.messageEditPosition = '';

              if (error.response.status === 409) {
                this.successfullEditPositionInside = false;

                setTimeout(() => {
                  this.messageEditPositionInside =
                    'Position already in use. Please, change its name.';
                }, 10);
              } else if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('user');
                this.$router.push('/');
              } else {
                this.successfullEditPosition = false;

                setTimeout(() => {
                  this.messageEditPosition =
                    'An error has occurred updating the position. Please, try again later.';
                }, 10);

                this.editPositionDialog = false;
                this.itemToEdit = {};
              }

              console.error(
                (error.response && error.response.data) || error.message || error.toString()
              );

              this.editingPosition = false;
            }
          );
        } else {
          this.messageEditPositionInside = '';
          this.successfullEditPositionInside = false;

          setTimeout(() => {
            this.messageEditPositionInside = 'Please, fill all fields.';
          }, 10);
        }
      }
    },
    openDeletePosition(position) {
      this.itemToDelete = { ...position };
      this.deletePositionDialog = true;
    },
    deletePosition() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingPosition = true;

        PositionsDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllPositions(1);
              this.messageDeletePosition = '';
              this.successfullDeletePosition = true;

              setTimeout(() => {
                this.messageDeletePosition = 'Position successfully deleted.';
              }, 10);
            } else {
              this.messageDeletePosition = '';
              this.successfullDeletePosition = false;

              setTimeout(() => {
                this.messageDeletePosition =
                  'An error has occurred deleting the position. Please, try again later.';
              }, 10);
            }

            this.deletePositionDialog = false;
            this.deletingPosition = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeletePosition = '';
            this.successfullDeletePosition = false;

            setTimeout(() => {
              this.messageDeletePosition =
                'An error has occurred deleting the position. Please, try again later.';
            }, 10);

            this.deletePositionDialog = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deletingPosition = false;
          }
        );
      } else {
        this.messageDeletePosition = '';
        this.successfullDeletePosition = false;

        setTimeout(() => {
          this.messageDeletePosition =
            'An error has occurred deleting the position. Please, try again later.';
        }, 10);

        this.deletePositionDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(position) {
      this.itemToShow = { ...position };
      this.showDetailsPositionDialog = true;
    },
  },
};
</script>

<style scoped>
.intro-video-player {
  transform: none !important;
  object-fit: contain !important;
  background: #000 !important;
}

.visible-behaviour-name-col {
  min-width: 0;
}

.visible-behaviour-name {
  display: block;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
